import { getLanguage } from "assets/languages"
import {
  SET_CAMPAIGN_STEPS,
  SET_CAMPAIGN,
  SET_CAMPAIGN_RULES,
  SET_CAMPAIGN_BASE_RULES,
  RESET_CAMPAIGN_RULES,
  RESET_CAMPAIGN_STATE,
} from "./types"

const initialState = {
  steps: [
    { value: 1, selected: true, completed: false },
    { value: 2, selected: false, completed: false },
    { value: 3, selected: false, completed: false },
  ],

  campaign: {
    outputType: { name: "", value: 1 },
    brandManager: {
      countryCode: process.env.COUNTRY_CODE,
      mobile: process.env.LOCALE == "ko" ? `010-` : "080-",
      selectedCountryCode: { name: "", value: process.env.COUNTRY_CODE },
    },
    returnManager: {
      countryCode: process.env.COUNTRY_CODE,
      mobile: process.env.LOCALE == "ko" ? `010-` : "080-",
      selectedCountryCode: { name: "", value: process.env.COUNTRY_CODE },
    },
  },
  rules: { prohibitions: [], requirements: [], output: [], texts: [], select: [], images: [] },
  baseRules: {
    prohibitions: [],
    requirements: [],
    output: [],
    texts: [],
    select: [],
    images: [],
    logos: [],
  },
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CAMPAIGN_STEPS:
      const { value, selected, completed } = action.payload

      const updatedSteps = state.steps.map((step) => {
        if (step.value === value) {
          return { ...step, selected: selected || step.selected, completed }
        } else {
          return { ...step, selected: false }
        }
      })

      return {
        ...state,
        steps: updatedSteps,
      }
    case SET_CAMPAIGN:
      return {
        ...state,
        campaign: { ...state.campaign, ...action.payload },
      }
    case SET_CAMPAIGN_RULES:
      // Handle function updater pattern
      if (action.isUpdater && typeof action.payload === 'function') {
        const updatedRules = action.payload(state.rules)
        return {
          ...state,
          rules: updatedRules
        }
      }
      
      // Handle direct object updates
      const { prohibitions, requirements, output, texts, select, images } = action.payload

      const filterRulesByGroupName = (rules, filterItems) =>
        rules?.filter((item) => !filterItems?.find((rule) => rule.groupName === item.groupName))

      const filteredEmptyTexts = (texts || []).filter((rule) => rule.value?.length > 0)

      const mergedTexts = [...(filteredEmptyTexts || []), ...filterRulesByGroupName(state.rules.texts, texts)]

      const mergedProhibitions = [
        ...(prohibitions || []),
        ...filterRulesByGroupName(state.rules.prohibitions, prohibitions),
      ]

      const mergedRequirements = [
        ...(requirements || []),
        ...filterRulesByGroupName(state.rules.requirements, requirements),
      ]

      const mergedSelect = [...(select || []), ...filterRulesByGroupName(state.rules.select, select)]

      return {
        ...state,
        rules: {
          ...state.rules,
          ...(prohibitions && {
            prohibitions: mergedProhibitions,
          }),
          ...(requirements && {
            requirements: mergedRequirements,
          }),
          ...(output && { output }),
          ...(texts && { texts: mergedTexts }),
          ...(select && { select: mergedSelect }),
          ...(images && { images }),
        },
      }
    case SET_CAMPAIGN_BASE_RULES:
      return {
        ...state,
        baseRules: {
          ...action.payload,
        },
      }
    case RESET_CAMPAIGN_RULES:
      return {
        ...state,
        rules: {
          ...initialState.rules,
        },
      }
    case RESET_CAMPAIGN_STATE:
      return {
        ...initialState,
        campaign: {
          ...initialState.campaign,
          ...action.payload,
        }
      }
    default:
      return state
  }
}
export default reducer
